import React from 'react';
import { PUBLIC_URL } from '../../__common/env';
import { observer } from 'mobx-react-lite';

export const Searchbar = observer(({ value, onChange }) => {
    return (
        <div className="mt-[24px] w-[292px] h-[48px] pl-[16px] py-[8px] border-[1px] gap-[16px] border-theme-button-bg rounded-[2.25rem] flex items-center">
            <img
                src={`${PUBLIC_URL}/assets/icons/search_icon.svg`}
                alt=""
                className="h-[24px] w-[24px] object-contain"
            />
            <input
                type="text"
                placeholder="Search"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="outline-none text-sm"
            />
        </div>
    );
});
